import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ItemTitle from '../type/item-title';
import Text from '../type/text';
import { marginClassNamePropType } from '../__utils/spacingClassNamePropType';

import './style.scss';

const Legend = ({ groups, className, qaId }) => {
  const groupElements = groups.map(group => [
    (group.categoryName ?
      <span className="uni-legend__category" key={`category-${group.categoryName}`}>
        <ItemTitle level="default" isCaps>
          {group.categoryName}
        </ItemTitle>
      </span>
      : null),
    <div className="uni-legend__items" key={`items-${group.categoryName}`}>
      {group.items.map(item => (
        <span key={item.label} className="uni-legend__item">
          <span className="uni-legend__item-symbol">{item.symbol}</span>
          <span className="uni-legend__item-label">
            <Text level="small">{item.label}</Text>
          </span>
        </span>
      ))}
    </div>,
  ]);

  const legendClasses = classNames('uni-legend', {
    [className]: className,
  });

  return <div className={legendClasses} data-qa-id={qaId}>{groupElements}</div>;
};

Legend.propTypes = {
  groups: PropTypes.arrayOf(
    PropTypes.shape({
      categoryName: PropTypes.string,
      items: PropTypes.arrayOf(
        PropTypes.shape({
          symbol: PropTypes.element.isRequired,
          label: PropTypes.string.isRequired,
        })
      ).isRequired,
    })
  ).isRequired,
  className: marginClassNamePropType,
  qaId: PropTypes.string,
};

Legend.defaultProps = {
  className: 'uni-margin--one',
};

export default Legend;



// WEBPACK FOOTER //
// ./src/legend/index.jsx